import { Link } from 'react-router-dom';
import { FileText, Wallet } from 'lucide-react';

const legalFacts = [
  ['Juridische entiteit', 'Buybeez'],
  ['Vestigingsland', 'Nederland'],
  ['E-mail', 'budgettoppers@buybeez.nl'],
  ['KvK', '92484476'],
  ['BTW', 'NL004956879B14'],
  ['D-U-N-S', '494977417'],
];

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-background">
      <header className="border-b border-border bg-white/95 backdrop-blur">
        <div className="mx-auto flex max-w-5xl items-center justify-between gap-4 px-4 py-4 sm:px-6 sm:py-5">
          <Link to="/" className="flex items-center gap-3 text-foreground">
            <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary text-primary-foreground">
              <Wallet className="h-5 w-5" />
            </div>
            <span className="font-heading text-lg font-bold">budgettoppers</span>
          </Link>
          <Link to="/" className="shrink-0 text-sm font-medium text-muted-foreground transition-colors hover:text-foreground">
            Terug naar home
          </Link>
        </div>
      </header>

      <main className="mx-auto max-w-5xl px-4 py-8 sm:px-6 sm:py-12">
        <div className="mb-6 flex items-start gap-4 rounded-3xl border border-border bg-white p-6 shadow-card sm:mb-10 sm:p-8">
          <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-primary/10 text-primary">
            <FileText className="h-6 w-6" />
          </div>
          <div className="min-w-0">
            <p className="mb-2 text-sm font-semibold uppercase tracking-[0.2em] text-primary">Voorwaarden</p>
            <h1 className="font-heading text-3xl font-bold leading-tight text-foreground sm:text-4xl">Algemene voorwaarden</h1>
            <p className="mt-3 max-w-2xl text-base leading-7 text-muted-foreground">
              Deze pagina geeft een heldere samenvatting van de belangrijkste afspraken rond het gebruik van
              budgettoppers als online dienst.
            </p>
          </div>
        </div>

        <div className="grid gap-6 lg:grid-cols-[1.7fr_1fr] lg:items-start">
          <article className="space-y-6 rounded-3xl border border-border bg-white p-6 shadow-card sm:p-8">
            <section className="space-y-3">
              <h2 className="font-heading text-xl font-semibold leading-tight sm:text-2xl">1. Toepassing</h2>
              <p className="text-base leading-7 text-muted-foreground">
                Deze voorwaarden zijn van toepassing op het gebruik van budgettoppers en de bijbehorende website,
                dashboards en aanverwante digitale diensten.
              </p>
            </section>

            <section className="space-y-3">
              <h2 className="font-heading text-xl font-semibold leading-tight sm:text-2xl">2. Gebruik van de dienst</h2>
              <p className="text-base leading-7 text-muted-foreground">
                Je bent verantwoordelijk voor het juist invullen en actueel houden van je accountgegevens. Gebruik van
                de dienst moet rechtmatig zijn en mag de veiligheid, beschikbaarheid of integriteit van de dienst niet
                schaden.
              </p>
            </section>

            <section className="space-y-3">
              <h2 className="font-heading text-xl font-semibold leading-tight sm:text-2xl">3. Beschikbaarheid en wijzigingen</h2>
              <p className="text-base leading-7 text-muted-foreground">
                budgettoppers mag functionaliteit aanpassen, verbeteren of onderhouden wanneer dat nodig is voor
                kwaliteit, veiligheid of continuiteit van de dienst.
              </p>
            </section>

            <section className="space-y-3">
              <h2 className="font-heading text-xl font-semibold leading-tight sm:text-2xl">4. Verantwoordelijkheid</h2>
              <p className="text-base leading-7 text-muted-foreground">
                Inzichten en overzichten in budgettoppers zijn bedoeld als hulpmiddel. De gebruiker blijft zelf
                verantwoordelijk voor financiële beslissingen, contractkeuzes en de juistheid van aangeleverde data.
              </p>
            </section>

            <section className="space-y-3">
              <h2 className="font-heading text-xl font-semibold leading-tight sm:text-2xl">5. Beëindiging</h2>
              <p className="text-base leading-7 text-muted-foreground">
                Toegang tot de dienst kan worden beëindigd of beperkt bij misbruik, veiligheidsrisico’s, fraude of
                andere zwaarwegende redenen die een verantwoord gebruik van het platform in de weg staan.
              </p>
            </section>
          </article>

          <aside className="rounded-3xl border border-border bg-muted/30 p-5 sm:p-6">
            <h2 className="font-heading text-xl font-semibold leading-tight">Juridische gegevens</h2>
            <dl className="mt-4 space-y-3 text-sm">
              {legalFacts.map(([label, value]) => (
                <div key={label} className="rounded-2xl border border-border bg-white px-4 py-3 text-left">
                  <dt className="text-xs uppercase tracking-[0.14em] text-muted-foreground">{label}</dt>
                  <dd className="mt-1 break-words text-sm font-medium leading-6 text-foreground">{value}</dd>
                </div>
              ))}
            </dl>
          </aside>
        </div>
      </main>
    </div>
  );
}
